/**
 * PGSS-5562 — what to report after Complete & Ship.
 *
 * The shipment completes either way. Its orders are a different matter: they only take the
 * shipped status once the container has actually been received (PGSS-4912), and otherwise hold at
 * Shipment Confirmation Pending.
 *
 * The dialog used to show its own fixed `successMessage` and throw the server's away, so a hold
 * read exactly like a completion. Staff were told it worked, saw nothing move, and tried again —
 * which is how PGSS-5361 came in as an intermittent glitch rather than a rule doing its job.
 *
 * Its own module so the decision is testable against the real thing rather than a copy of it,
 * the same reason `paymentReversalScope` and `archivedInvoiceReversal` were extracted.
 */
export default function completeShipmentMessage(res, cannedSuccessMessage) {
  // Only an explicit true counts. A server from before this shipped sends no flag at all, and
  // treating anything truthy as held would put a warning on every successful completion.
  const ordersHeld = res?.ordersHeld === true;
  return {
    message: ordersHeld ? res.message : cannedSuccessMessage,
    type: ordersHeld ? 'warning' : 'success',
  };
}
